<template lang="pug">
    v-data-iterator(
        item-key="id"
        content-tag="v-layout"
        no-data-text="No videos available"
        row
        wrap
        :items="sessions"
        hide-actions
    )
        template(v-slot:item="props" )
            v-flex(xs12 sm6 md4 lg3 xl2)
                meditation-component(:item="props.item" :handlePlay="handlePlay" :key="props.item.id" :index="props.index")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        components: {
            MeditationComponent: () => import('./Meditation')
        },
        props: {
            sessions: VueTypes.array.def([])
        },
        methods: {
            handlePlay(sessionId) {
                const params = {
                    theme: this.theme,
                    id: this.id,
                    session: this.sessions.find(
                        session => session.id === sessionId
                    )
                };

                return this.$router.push({
                    name: 'dashboard.pagesSession',
                    params
                });
            }
        }
    };
</script>
